/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class AdminGoldensetResultService {

  constructor(private http: HttpClient) { }


  getList() {
    return this.http
      .get(
        `/api/v1/admin/goldenset/list`
      );
  }

  getIncorrect(runId: string) {
    return this.http
      .get(
        `/api/v1/admin/goldenset/incorrect/${runId}`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-goldenset-result.service.ts